import { AppStateDeclaration } from '../AppStateDecleration';
import { LazyReact } from 'ui/components/shared/LazyReact';

export const newPipelineRouteNames = {
  list: 'dashboard.parsing-rules-hub',
  new: 'dashboard.new-parsing-rule',
  inspect: 'dashboard.inspect-parsing-rule',
};

export const parsingRuleRoutes: AppStateDeclaration[] = [
  {
    name: newPipelineRouteNames.list,
    url: `/parsing-rules-hub`,
    component: props => (
      <LazyReact
        lazyImport={() => import('ui/components/Parser/ParsingRulesHub')}
        resolver={({ ParsingRulesHub }) => ParsingRulesHub}
        {...props}
      />
    ),
    data: {
      authenticate: true,
      title: 'Parsing rules hub',
      breadcrumb: { label: 'Parsing rules hub' },
    },
  },
  {
    name: newPipelineRouteNames.new,
    url: `/parsing-rules-hub/new`,
    component: props => (
      <LazyReact
        lazyImport={() => import('ui/components/Parser/ParsingRuleForm')}
        resolver={({ ParsingRuleForm }) => ParsingRuleForm}
        {...props}
      />
    ),
    data: {
      authenticate: true,
      title: 'Create Parsing Rule',
      breadcrumb: { label: 'Create Parsing Rule', parent: newPipelineRouteNames.list },
    },
  },
  {
    name: newPipelineRouteNames.inspect,
    url: `/parsing-rules-hub/:id?viewMode`,
    component: props => (
      <LazyReact
        lazyImport={() => import('ui/components/Parser/ParsingRuleForm')}
        resolver={({ ParsingRuleForm }) => ParsingRuleForm}
        {...props}
      />
    ),
    data: {
      authenticate: true,
      title: 'View Parsing Rule',
      breadcrumb: { label: 'View parsing rule', parent: newPipelineRouteNames.list },
    },
  },
];
